export default __webpack_public_path__ + "static/step5-0a99f7bdc5c095888256ff83b6d670fc.webp";